export const FETCH_TABLES_ERROR = "Error fetching Tables from Bumblebee. Please retry the last action.";
export const FETCH_TABLE_DETAILS_ERROR = "Error fetching Table Details from Bumblebee. Please retry the last action.";
export const BUMBLEBEE_SOURCE = "Bumblebee";
